const config = {
  bucketName: process.env.REACT_APP_BUCKET_NAME,
  region: process.env.REACT_APP_REGION,
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
};
export default config;
